module.exports = __webpack_public_path__ + "img/dashboard.b01a5651.svg";